module.exports = __webpack_public_path__ + "static/media/996442.63dd6d22.png";